import React from 'react'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { IconList } from '../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../shared/card/card-full-height-scroll-y'
import { TableAgClient } from '../../../../shared/table-builder/table-ag-client'
import { ColumnMenu, ColumnText } from '../../../../shared/table-builder/table-columns'
import { Menu, MenuPurge, MenuRestore } from '../../../../shared/menu/menu'
import { useRouteMatch } from 'react-router-dom'
import { useApiListAnalyticParentType } from '../../../../api-new/state/analytics'
import { recycleErrorMessage } from '../../../../shared/error/server-message'
import { ErrorReference } from '../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../shared/error/use-error-line'

export const AnalyticParentTypeRecycle = () => {
  const { url } = useRouteMatch()

  const apiListAnalyticParentType = useApiListAnalyticParentType()

  const [error, failure, setError] = useErrorLine()

  const handleReady = () => apiListAnalyticParentType.get('deleted')
  const handleDestroyed = () => apiListAnalyticParentType.init()

  const handleRestore = async data => {
    setError(null)
    try {
      await apiListAnalyticParentType.put(`${data.id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That analytic parent type was already removed.'), err)
    }
    await apiListAnalyticParentType.get('deleted')
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="Recycle">
        <CardFullHeightScrollY title="Recycle Bin">
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient apiList={apiListAnalyticParentType} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="name" />
            <ColumnText field="description" />
            <ColumnText field="analyticCount" header="Analytics" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row)} show />
                  <MenuPurge to={`${url}/${row.id}/purge`} show />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
